module.exports = __webpack_public_path__ + "static/media/gemini.58bd938b.svg";